export default {
    changePassword: 'เปลี่ยนรหัสผ่าน',
    newPassword: 'รหัสผ่านใหม่',
    save: 'บันทึก',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'รหัสผ่านเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    passwordOfUserIsUpdated: 'รหัสผ่านผู้ใช้งานถูกอัปเดตแล้ว'
}
